import type { RelatedProductsQuery } from '@algolia/recommend';
import { recommendClient } from './recommendClient';

export const getRelatedProducts = async ({ query }: { query: RelatedProductsQuery[] }) =>
  recommendClient.getRelatedProducts(query);
